import React from "react";
import { Form, Input, InputNumber, Select, Switch, ColorPicker, Collapse, Alert } from "antd";
import PushImageUrlUploadInput from "./push-image-url-upload-input";

const PRIORITY_OPTIONS = [
    { value: "high", label: "Cao (high)" },
    { value: "normal", label: "Thường (normal)" },
];

/**
 * Tùy chọn hiển thị nâng cao cho push (FCM). Thuần presentational — các Form.Item
 * dùng chung instance Form của parent. Tất cả optional; field rỗng sẽ bị parent
 * lược bỏ trước khi gửi (xem buildRichOptions trong form).
 *
 * Lưu ý ColorPicker (antd v5) trả về object AggregationColor → parent normalize hex.
 */
function PushRichOptions() {
    const fields = (
        <div className="grid grid-cols-2 gap-x-6">
            <Alert
                className="col-span-2 mb-4"
                type="info"
                showIcon
                message={
                    <span>
                        Nên nén ảnh trước khi tải lên bằng{" "}
                        <a href="https://squoosh.app/" target="_blank" rel="noopener noreferrer">squoosh.app</a>{" "}
                        (WebP/MozJPEG, ảnh lớn ~200KB, tỉ lệ 2:1 vd 1024×512). Ảnh nặng làm push hiện chậm
                        hoặc mất ảnh — FCM bỏ ảnh &gt; 1MB.
                    </span>
                }
            />
            <Form.Item name="image" label="Ảnh lớn" className="col-span-2">
                <PushImageUrlUploadInput kind="image" placeholder="https://.../banner.jpg hoặc bấm Tải lên" />
            </Form.Item>
            <Form.Item name="icon" label="Icon" tooltip="Ảnh vuông, tự thu về 256×256 PNG">
                <PushImageUrlUploadInput kind="icon" placeholder="https://.../icon.png" />
            </Form.Item>
            <Form.Item name="color" label="Màu nhấn (Android)">
                <ColorPicker format="hex" allowClear />
            </Form.Item>
            <Form.Item name="priority" label="Độ ưu tiên" initialValue="high">
                <Select options={PRIORITY_OPTIONS} />
            </Form.Item>
            <Form.Item name="badge" label="Badge (số)">
                <InputNumber min={0} max={9999} style={{ width: "100%" }} placeholder="vd: 1" />
            </Form.Item>
            <Form.Item name="ttl" label="TTL (giây)" tooltip="Thời gian sống của push; quá hạn không gửi nữa">
                <InputNumber min={0} style={{ width: "100%" }} placeholder="vd: 86400" />
            </Form.Item>
            <Form.Item name="collapseKey" label="Collapse key" tooltip="Push cùng key sẽ gộp/ghi đè nhau">
                <Input placeholder="vd: promo" allowClear />
            </Form.Item>
            <Form.Item name="silent" label="Im lặng (không kêu/rung)" valuePropName="checked">
                <Switch />
            </Form.Item>
        </div>
    );

    return (
        <Collapse
            ghost
            items={[{ key: "adv", label: "Tùy chọn nâng cao", children: fields }]}
        />
    );
}

export default PushRichOptions;
